import React from "react";

const Footer = () => (
  <footer className="site-footer">
    <div className="wrap site-footer-inner">
      <span>© {new Date().getFullYear()} Elad Hodeda</span>
      <a href="#top">Back to top ↑</a>
    </div>
  </footer>
);

export default Footer;
